<template>
    <div class="feature-section-container">
        <div class="section-header">
            <h3>おすすめポイント</h3>
        </div>
        <div class="section-content">
            <div class="feature-item">
                <div class="feature-title-wrapper">
                    <span class="icon rank-1-icon">1</span>
                    <h4 class="feature-title"><span class="bold-red under-yellow">最大91%OFF！</span>業界最安値クラスの料金</h4>
                </div>
                <img src="../../assets/rank1/point1.png" alt="">
                <p class="feature-description">
                    給湯器駆けつけ隊は、メーカーから直入れすることで中間マージンをカットしており、安心の品質をお手頃価格でご提供しています。
                </p>
                <p class="feature-description">実際に他社の見積もりと比較しても、<span class="bold-red">圧倒的な格安で給湯器を交換できる</span>ことがわかります。
                </p>
                <p class="scroll-text blink">横にスクロールできます→→→</p>
                <div class="mitumori">
                    <div class="mitumori-card">
                        <p class="mitumori-label ours">給湯器駆けつけ隊の見積もり</p>
                        <p class="total-cost2">総額 : <span>230,280円（税込）</span></p>
                        <img src="../../assets/rank1/point-1-2.png" alt="給湯器駆けつけ隊の見積もり">
                    </div>
                    <div class="mitumori-card">
                        <p class="mitumori-label other">他社の見積もり例</p>
                        <p class="total-cost bold-font">総額 : 498,000円（税込）</p>
                        <img src="../../assets/rank1/point-1-1.png" alt="他社の見積もり">
                    </div>
                </div>
            </div>

            <div class="feature-item point2">
                <div class="feature-title-wrapper">
                    <span class="icon">2</span>
                    <h4 class="feature-title"><span class="bold-red under-yellow">最短30分</span>で駆けつけ！</h4>
                </div>
                <img src="../../assets/rank1/point2.png" alt="">
                <p class="feature-description">他社では数日かかるところを、給湯器駆けつけ隊であれば<span class="bold-red">最短30分で駆けつけ可能</span>です。
                </p>
                <p class="feature-description">利用者の口コミでは「<span
                        class="bold-red">その日のうちにお湯が使えるようになった</span>」という声も多く、急な故障時でも安心感があります。</p>
            </div>

            <div class="feature-item point3">
                <div class="feature-title-wrapper">
                    <span class="icon">3</span>
                    <h4 class="feature-title">工事・商品の<span class="bold-red under-yellow">１０年無料保証付き</span></h4>
                </div>
                <img src="../../assets/rank1/point-3-1.png" alt="" style="width: 100%;">
                <p class="feature-description">
                    給湯器駆けつけ隊では、工事保証と商品保証が無料で10年間ついており、<span class="bold-red">保証期間中は修理回数の制限なしで対応してもらえます。</span>
                </p>
                <p class="feature-description">
                    給湯器設置後に「お湯が出ない」「追いだきが途中で止まる」「異音がする」などのトラブルが起きても、 <span class="bold-red">10年間は修理費用がかかりません。</span>
                </p>

                <details class="accordion">
                    <summary>保証範囲を詳しく見る</summary>
                    <div class="accordion-content">
                        <p>
                            設置から10年以内に通常通りに使用しており、修理が必要になった場合は、修理費・出張費・部品代は無料となります。<br><br>但し、保証期間内であっても、次に該当する故障の場合は保証対象外となります。
                        </p>
                        <ul class="warranty-list">
                            <li>① 天災（地震・火災・台風等）の災害により生じた不具合</li>
                            <li>② 入居者（管理人含む）または、第三者の過失により発生した不具合</li>
                            <li>③ 保証対象以外の部分（当社施工時に関係の無い場所）が原因により発生した不具合</li>
                            <li>④ 物件所有者の変更やリフォーム等による利用条件の変更が発生した場合</li>
                            <li>⑤ その他明らかに弊社の施工に起因しない事由による不具合</li>
                        </ul>
                    </div>
                </details>
                <!-- ▲ ここまでアコーディオン -->
            </div>

            <div class="feature-item no-border point4">
                <div class="feature-title-wrapper">
                    <span class="icon">4</span>
                    <h4 class="feature-title">お客様満足度<span class="bold-red under-yellow">97.3%！</span></h4>
                </div>
                <img src="../../assets/rank1/point4.png" alt="">
                <p class="feature-description">給湯器駆けつけ隊は、口コミでも高い評価を受けています。</p>
                <p class="feature-description">実際に、各営業所の<span class="bold-red">Google口コミ評価を見ても4.8を超えており</span>、
                    利用されたお客様からは</p>
                <p class="feature-description">「<strong>他の業者と比較して一番安かった</strong>」<br>「<strong>対応スピードが早くて丁寧</strong>」</p>
                <p class="feature-description">といった声が数多く寄せられています。</p>
                <!-- <img src="../../assets/rank1/review.png" alt=""> -->
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'FeatureSection',
    data() {
        return {
            currentYear: new Date().getFullYear(),
            currentMonth: new Date().getMonth() + 1
        };
    }
};
</script>

<style scoped>
.feature-section-container {
    background-color: white;
    margin-top: 0;
    padding: 10px;
}

.section-header {
    background-color: #3f51b5;
    color: white;
    padding: 10px 10px;
    margin-bottom: 20px;
    position: relative;
    text-align: center;
}

.section-header h3 {
    margin: 0;
    font-size: 1.2rem;

    /* ▼ 追加：中央のタイトル装飾 */
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 8px 18px;
    border-radius: 999px;
    letter-spacing: .03em;
    font-weight: 900;
    position: relative;
}

/* ▲ ここまで追加 */

.feature-item {
    margin-bottom: 20px;
    border-bottom: 3px dotted gray;
}

.feature-item.no-border {
    border-bottom: none;
    margin-bottom: 0;
}

.annotation-txt {
    margin: 0;
    padding: 0;
    text-align: right;
    margin-bottom: 5px;
}

.feature-title-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    background: #eeeeee;
    padding: 10px;
    border-left: 5px solid gray;
}

.point-3 {
    width: 100%;
}

.icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    background-color: #ffc107;
    color: white;
    font-weight: bold;
    border-radius: 50%;
    margin-right: 10px;
}

.feature-title {
    font-size: 1.05rem;
    font-weight: bold;
    color: #333;
    margin: 0;
}

.feature-description {
    color: #555;
    line-height: 1.5;
    text-align: left;
    padding: 5px;
    padding-top: 0;
    font-size: 0.85rem;
}

.image-box {
    width: 100%;
    border-radius: 5px;
    overflow: hidden;
    margin-bottom: 20px;
}

.image-box.yellow-border {
    border: 2px solid #ffc107;
}

.feature-image {
    width: 100%;
    height: auto;
    display: block;
}

.section-content {
    padding: 15px;
    padding-top: 0;
    padding-bottom: 0;
}

.feature-item img {
    width: 100%;
    margin-bottom: 20px;
}

.point3 img {
    width: 80%;
    margin-top: 10px;
}

.point2 img,
.point4 img {
    width: 90%;
    margin-top: 10px;
    border-radius: 20px;
}

.mitumori {
    display: flex;
    overflow-x: auto;
    gap: 16px;
    padding: 10px 0;
    scroll-snap-type: x mandatory;
    margin-bottom: 15px;
}

.mitumori::-webkit-scrollbar {
    height: 6px;
}

.mitumori::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
}

.mitumori-card {
    flex: 0 0 80%;
    background: #fff;
    border: 1px solid #ddd;
    padding: 10px;
    scroll-snap-align: start;
    text-align: center;
}

.mitumori-card img {
    width: 100%;
    border-radius: 4px;
    margin-top: 8px;
}

.mitumori-label {
    font-weight: bold;
    font-size: 1rem;
    padding: 10px 20px;
    margin: 0;
    border-radius: 20px;
    display: inline-block;
}

.mitumori-label.other {
    background: gray;
    color: #fff;
}

.mitumori-label.ours {
    background: #3f51b5;
    color: #fff;
}

.total-cost {
    padding: 15px;
    background-color: #f1efef;
}

.total-cost2 {
    padding: 15px;
    background-color: #E91E63;
    font-weight: bold;
    color: #fff;
}

.scroll-text {
    text-align: right;
    margin-top: 0;
    margin-right: 15px;
    margin-bottom: 0;
    padding-top: 10px;
    font-size: 12px;
}

.feature-title {
    text-align: left;
}

.review-img {
    margin-bottom: 0;
    padding: 0;
}

@keyframes blinking {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.blink {
    animation: blinking 1s ease-in-out infinite alternate;
}

/* ====== 追加: アコーディオン専用 ====== */
.accordion {
    border: 1px solid #ddd;
    border-radius: 8px;
    margin: 10px 0;
    overflow: hidden;
    background: #fff;
}

.accordion>summary {
    cursor: pointer;
    padding: 12px 14px;
    font-weight: 700;
    color: gray;
    list-style: none;
    position: relative;
    outline: none;
    font-size: 0.8rem;
}

.accordion summary::-webkit-details-marker {
    display: none;
}

.accordion>summary::after {
    content: '＋';
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
}

.accordion[open]>summary {
    border-bottom: 1px dashed #ddd;
}

.accordion[open]>summary::after {
    content: '－';
}

.accordion-content {
    padding: 12px 14px;
    color: #555;
    line-height: 1.6;
    text-align: left;
}

.warranty-list {
    margin: 8px 0 0 0;
    padding: 0;
    list-style: none;
}

.warranty-list li {
    margin: 4px 0;
}

/* ====== 追加ここまで ====== */

/* ==================== スマホ対応 ==================== */
@media (max-width: 600px) {
    .section-content {
        padding: 5px;
    }

    .section-header h3 {
        font-size: 1.2rem;
        padding: 10px;
    }

    .section-header {
        padding: 10px;
    }

    .section-header::before,
    .section-header::after {
        width: 18px;
        height: 18px;
        left: 8px;
        right: 8px;
    }

    .icon {
        width: 20px;
        height: 20px;
        font-size: 1rem;
    }

    .feature-title {
        font-size: 1.2rem;
    }

    .accordion-content {
        font-size: 0.8rem;
    }

    .feature-description {
        font-size: 0.9rem;
    }

    .mitumori-label {
        font-size: 0.9rem;
        padding: 10px 15px;
    }

    .total-cost,
    .total-cost2 {
        font-size: 1rem;
    }

    .scroll-text {
        font-size: 0.7rem;
    }
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 480px) {

    .icon {
        width: 30px;
        height: 30px;
        font-size: 1.2rem;
    }

    .feature-title {
        font-size: 1.1rem;
    }

    .feature-description {
        font-size: 0.9rem;
    }

    .annotation-txt {
        font-size: 0.6rem;
    }
}
</style>
